import React from 'react'
import BackButton from '../../common/components/BackButton'
import ShareButton from './ShareButton'
import ZoomToButton from './ZoomToButton';
import { Parcel } from '../types';

interface ParcelDetailsButtonsProps {
  parcel: Parcel | undefined;
}

const ParcelDetailsButtons: React.FC<ParcelDetailsButtonsProps> = ({ parcel }) => {
  return (
    <div className="grid">
      <div className="col-1-3">
        <BackButton />
      </div>
      <div className="col-1-3">
        <ZoomToButton geometry={parcel?.geometry} />
      </div>
      <div className="col-1-3">
        <ShareButton />
      </div>
    </div>
  )
}

export default ParcelDetailsButtons